import PatternsStatus from '@mozaic-ds/gatsby-theme-styleguide/src/gatsby-components/PatternsStatus';
import * as React from 'react';
export default {
  PatternsStatus,
  React
};